<template>
  <div class="body-box marginBox2">
    <el-row class="plan" style="margin-bottom: 10px;"></el-row>
    <!--表单区域-->
    <el-form
      ref="editFormRef"
      :model="editForm"
      label-width="140px"
      style="padding: 20px; background-color: #fff;"
    >
      <el-row>
        <!--商品名字-->
        <el-col :span="8">
          <el-form-item label="商品名字">
            <el-input disabled v-model="editForm.name" placeholder="请输入商品名字" />
          </el-form-item>
        </el-col>

        <!--数量-->
        <el-col :span="8">
          <el-form-item label="数量">
            <el-input disabled v-model="editForm.num" placeholder="请输入数量" />
          </el-form-item>
        </el-col>

        <!--分类字典-->
        <el-col :span="8">
          <el-form-item label="分类">
            <el-cascader
              disabled
              style="width: 100%;"
              :options="classifyCheckList"
              :props="props"
              v-model="editForm.classifyId"
              clearable></el-cascader>
          </el-form-item>
        </el-col>

        <!--品牌字典-->
        <el-col :span="8">
          <el-form-item label="品牌">
            <el-select style="width: 100%;" disabled v-model="editForm.brandId" placeholder="请选择">
              <el-option
                v-for="item in brandCheckList"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--相关排序-->
        <el-col :span="8">
          <el-form-item label="相关排序">
            <el-input disabled v-model="editForm.absort" placeholder="请输入相关排序" />
          </el-form-item>
        </el-col>

        <!--首页排序-->
        <el-col :span="8">
          <el-form-item label="首页排序">
            <el-input disabled v-model="editForm.resort" placeholder="请输入首页排序" />
          </el-form-item>
        </el-col>
        <!--VIP商品-->
        <el-col :span="8">
          <el-form-item label="是否是VIP商品" prop="vipFlag">
            <el-switch
              disabled
              v-model="editForm.vipFlag"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-col>

        <!--型号-->
        <el-col :span="24" style="padding: 0 140px 20px 140px;font-size: 20px;margin-top: 30px;">
          <span>型号</span>
        </el-col>

        <!--型号-->
        <el-col :span="24">
          <el-form label-width="140px">
            <div v-for="(item,index) in editForm.modeList" :key="index">
              <el-row>
                <!--价格-->
                <el-col :span="8">
                  <el-form-item label="价格">
                    <el-input v-model="item.amount" placeholder="请输入价格" />
                  </el-form-item>
                </el-col>

                <!--兑换积分-->
                <el-col :span="8">
                  <el-form-item label="兑换积分">
                    <el-input v-model="item.integral" placeholder="请输入兑换积分" />
                  </el-form-item>
                </el-col>

                <!--型号-->
                <el-col :span="8">
                  <el-form-item label="型号">
                    <el-input v-model="item.mode" placeholder="请输入型号" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="所需积分">
                    <el-input v-model="item.score" placeholder="请输入所需积分" />
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="型号图片">
                    <thumbnail :md5s="item.icon" :uploadStatus="false"></thumbnail>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </el-col>

        <!--缩略图-->
        <el-col :span="24" class="label">
          <el-form-item label="缩略图">
            <thumbnail :uploadStatus="false" :md5s="editForm.thumbnail"></thumbnail>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="查看视频">
            <qq-video-new :videoMd5="editForm.video" :uploadStatus="false"></qq-video-new>
          </el-form-item>
        </el-col>

        <!--轮播图-->
        <el-col :span="24">
          <el-form-item label="轮播图">
            <thumbnail-list :uploadStatus="false" v-model="editForm.carousel" :md5List="editForm.carousel"></thumbnail-list>
          </el-form-item>
        </el-col>

        <!--富文本-->
        <el-col :span="24">
          <el-form-item label="富文本">
            <div v-html="editForm.brief"></div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="goBackBox"><el-button @click="goBack">返 回</el-button></div>
  </div>
</template>

<script>
import { getData } from '@/utils/code'
import { getDictsTree, selectDictByKey } from '@/api/user/dict/dict'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import { getGoodsById } from '@/api/goods/goods'
import QqVideoNew from '@/components/common/qqVideo/qqVideoNew'

export default {
  components: { QqVideoNew, ThumbnailList, Thumbnail },
  data() {
    return {
      title: '',
      editDialogVisible: false,
      editForm: {
        brandId: '', //品牌id
        classifyId: [], //分类id
        vipFlag: undefined,
        modeList: [
          {
            amount: '',
            icon: '',
            integral: '',
            mode: '',
            score: ''
          }
        ]
      }, //添加组织表单
      props: {
        multiple: true,
        checkStrictly: true,
        emitPath: false,
        value: 'id',
        label: 'name'
      },
      //初始化的值
      classifyCheckList: [],
      //初始化的值
      brandCheckList: [],
      queryClassifyInfo: {
        current: 1,
        size: 20,
        key: 'CLASSIFY'
      },
      queryBrandInfo: {
        current: 1,
        size: 20,
        key: 'BRAND'
      },
      goodsId: ''
    }
  },
  created() {
    this.goodsId = this.$route.query.id
    this.initialize()
    this.getClassify()
    this.getBrand()
  },
  methods: {
    //初始化
    initialize() {
      getGoodsById(this.goodsId).then(res => {
        console.log('s', res.data)
        this.editForm = res.data
      })
    },

    //返回
    goBack() {
      this.$router.go(-1)
    },

    //查询分类字典
    getClassify() {
      getDictsTree('CLASSIFY').then(res => {
        this.classifyCheckList = res.data
      })
    },

    //查询品牌字典
    getBrand() {
      this.getDictByKey(this.queryBrandInfo.key).then((result) => {
        this.brandCheckList = result
      })
    },

    //字典
    getDictByKey(query) {
      return new Promise((resolve, reject) => {
        selectDictByKey(query).then((response) => {
          let data = getData(response) ? getData(response) : []
          resolve(data)
        }).catch(() => {
          reject([])
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.el-input {
  width: 90%;
}
/deep/.el-form-item__label {
  text-align: left;
}
</style>
